import { html, View } from 'rune-ts';
import klass from './CreatorThumbnail.module.scss';
import { CreatorConstantS, CreatorTypeS } from '../../../../features/Creator/outbound/share';
import { getResizedUrl, type ResizedUrlOption } from '../../../../shared/util/image';

type CreatorThumbnailProps = CreatorTypeS.CreatorCardType & {
  resize_width: number;
};

interface CreatorThumbnailOption {
  klass?: string;
  adult_check_needed?: boolean;
}

export class CreatorThumbnail extends View<CreatorThumbnailProps> {
  state: CreatorThumbnailOption;
  resize_url_data: ResizedUrlOption;

  constructor(props: CreatorThumbnailProps, option: CreatorThumbnailOption = {}) {
    super({ ...props });

    const creator_thumbnail_img = this.data.thumbnail_img || CreatorConstantS.thumbnail_img;

    this.state = {
      klass: option.klass ?? klass.creator_thumbnail,
      adult_check_needed: option.adult_check_needed,
    };

    this.resize_url_data = {
      url: creator_thumbnail_img,
      width: this.data.resize_width,
      format: 'webp',
      quality: 80,
    };
  }

  override template() {
    return html`
      <img class="${this.state.klass}" src="${getResizedUrl(this.resize_url_data)}" alt="${this.data.name}" />
    `;
  }
}
